import {
  SET_LEFT_NAV_DATA,
  SELECTED_NAV_ITEM,
  RETURN_INITIAL_NAV_DATA,
  UPDATE_INITIAL_NAV_DATA,
} from '@/store/modules/left-nav-customization/mutation-types';

import {axiosClient} from '@/core/services/http.service';

export const getLeftNavData = async ({commit}, onlyVisible) => {
  const {success, body} = await axiosClient.get('/api/leftNav');
  if(success){
    commit(SET_LEFT_NAV_DATA, body);
  }
};
export const setSubItemName = ({commit, rootState}, payload)=> {
  const sidebarState = rootState.sidebar;
  const getName = (item) => {
    const module = sidebarState.modulesList[item.moduleGuid || item.id];
    if (module) {
      return module.label;
    }
    const folder = sidebarState.foldersList[item.folderGuid || item.id];
    if (folder) {
      return folder.label;
    }
    const entity = sidebarState.tablesList[item.entityGuid || item.id];
    if (entity) {
      return entity.label;
    }
  };

  payload.subItems?.forEach(item => item.name = getName(item));
  commit(SELECTED_NAV_ITEM, payload);

};
export const saveLeftNavData = async ({commit}, data) => {
  const {success, body} = await axiosClient.post('/api/leftNav', data);
  if(success){
    commit(UPDATE_INITIAL_NAV_DATA, data);
  }
  return {success, body};
};

export const returnInitialNavData = ({commit}) => {
  commit(RETURN_INITIAL_NAV_DATA);
};

export const clearSelectedItem = ({commit}) => {
  commit(SELECTED_NAV_ITEM, null);
};